import { InjectionToken } from '@angular/core';
import type { BulkActionLabelsProvider } from './bulk-action-labels-provider.interfaces';

export const BULK_ACTION_LABELS_PROVIDER =
  new InjectionToken<BulkActionLabelsProvider | null>(
    'BULK_ACTION_LABELS_PROVIDER',
  );
